import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminApp from './admin/AdminApp';
import BuyerApp from './buyer/BuyerApp';
import SellerApp from './seller/SellerApp';
import VendorApply from './vendors/VendorApply';
import MarketplaceApp from './marketplace/MarketplaceApp';
import TransactionApp from './transaction/TransactionApp';
import ShareApp from './share/ShareApp';
import DemoApp from './demo/DemoApp';
import BrokerApp from './broker/BrokerApp';
import AccountApp from './account/AccountApp';
import VendorPortalApp from './vendor-portal/VendorPortalApp';
import AuthGate from './components/AuthGate';

const path = window.location.pathname;
const isAdmin       = path.startsWith('/admin');
const isBuy         = path.startsWith('/buy');
const isSell        = path.startsWith('/sell');
const isJoin        = path.startsWith('/join');
const isMarketplace = path.startsWith('/marketplace');
const isTx          = path.startsWith('/tx');
const isShare       = path.startsWith('/share');
const isDemo        = path.startsWith('/demo');
const isPublic      = path.startsWith('/public');
const isBroker      = path.startsWith('/broker');
const isAccount     = path.startsWith('/account');
const isVendorPortal = path.startsWith('/vendor');

const isDemoSell = isSell && new URLSearchParams(window.location.search).get("demo") === "1";

const pick = () => {
  if (isAdmin)       return <AdminApp />;
  if (isBuy)         return <AuthGate role="buyer"><BuyerApp /></AuthGate>;
  if (isSell)        return isDemoSell ? <SellerApp /> : <AuthGate role="seller"><SellerApp /></AuthGate>;
  if (isJoin)        return <VendorApply />;
  if (isMarketplace) return <MarketplaceApp />;
  if (isTx)          return <TransactionApp />;
  if (isShare)       return <ShareApp />;
  if (isDemo)        return <DemoApp />;
  if (isPublic)      return <App />;
  if (isBroker)      return <AuthGate role="broker"><BrokerApp /></AuthGate>;
  if (isAccount)     return <AuthGate><AccountApp /></AuthGate>;
  if (isVendorPortal) return <AuthGate role="vendor"><VendorPortalApp /></AuthGate>;
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>{pick()}</React.StrictMode>
);
